import { type ChartColorValue } from "../../models/historical-charts/colors.values";

export const COLORS: Array<ChartColorValue> = [
  '#2C3280', '#3742E2', '#737BE9', '#D7D9F8',
  '#FFF2E4', '#FFDD00', '#FCA842', '#ED731C',
  '#CF4C06', '#702700'
]
